/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE CLASS NAME*/
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class backenddataService {
    private _httpInProgress = new BehaviorSubject<boolean>(false);
    httpInProgress$ = this._httpInProgress.asObservable();

    setHttpInProgress(state: boolean) {
        this._httpInProgress.next(state);
    }
}
